import React, { useState, useContext, useEffect } from 'react';
import { AppContext, AuthContext } from 'Context';
import { useNavigate } from 'react-router-dom';
import './UserM.css';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { removeDummy, clearAllDummys, saveDummy, clearUploadDetails, saveUploadInfo } from 'store/store';
import { CircularProgress as MuiCircularProgress, withStyles, makeStyles, Grid, IconButton, CircularProgress, Tooltip } from '@material-ui/core';
import { baseUrl, firebaseCredentials } from 'Api';
import { ReactComponent as HiddenIcon } from 'Assets/eye.slash.svg';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import EmailIcon from '@material-ui/icons/Email';
import { ref, get, getDatabase, off, onValue, update } from 'firebase/database';
import { initializeApp } from 'firebase/app';
import axios from 'axios';
import { InfoModal } from '../private/dashboard/info-modal/index';

function ManagerList({ isLoading, fetchMangerData, getToken, hiddenIndices, setHiddenIndices, userListData, setUserListData }) {
  const dispatch = useDispatch();
  const { handleClick, setIamUploading, firebaseDatabase, setEncounterLoading, autoSignIn, setbigUserData, isTokenChange, iamUploading, getSubscription, setmessaged, setmangerFunctionData, setUploadContainer, setAppSnackbar, draftOfUpload, setActiveUploads, setUploadQueue, setOpen } = useContext(AppContext);
  const navigate = useNavigate();
  const tokens = getToken();
  const [isOpenInfoModal, setInfoModal] = useState(false);
  const [userObject, setUserObject] = useState();
  const [userIamChanging, setuserIamChanging] = useState(false);
  const [visibleEye, setVisibleEye] = useState(Array(userListData?.data?.length).fill(false));
  const [isInviting, setIsInviting] = useState(false);
  const databaseRef = ref(firebaseDatabase, 'status_from_sns');
  const changeFieldFromFirebase = (draft_id, statusString) => {
    const dataToUpdate = {
      [draft_id]: {
        status: statusString,
      },
    };
    update(databaseRef, dataToUpdate);
  };
  const clearAllDummy = () => {
    dispatch(clearAllDummys());
};
  const switchingFunction = async (obj) => {
      try {
        const formData = new FormData();
        formData.append('token', tokens);
        formData.append('user_id', obj.userId);
        formData.append('user_token', obj.token);
        const response = await axios.post(`${baseUrl}/managerUserLogs`, formData);
        if (response?.data?.success === true) {
          clearAllDummy();
          handleClick(obj);
          localStorage.setItem('firstname', obj?.firstname || '');
          localStorage.setItem('lastname', obj?.lastname || '');
          navigate('/dashboard');
          getSubscription();
          autoSignIn();
        } else {
          setmessaged(response?.data?.message);
          setmangerFunctionData(true);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error); // Handle any errors
      }
  };
  const uploadPercentages = useSelector((state) => state.upload);
  const managerTokenFunction = async (obj) => {
    const uploadingOrNot = Object.values(uploadPercentages).some(
      (value) => typeof value === 'number' || value === 'Starting Upload'
    );
    if (!uploadingOrNot) {
      clearAllDummy();
      switchingFunction(obj);
    } else {
      setmessaged('You are uploading, so not able to access');
      setInfoModal(true);
    }
  };

  // Silent refresh - fetches data without showing loader
  const silentRefreshData = async () => {
    try {
      const apiUrl = `${baseUrl}/managerUsersList`;
      const requestBody = {
        token: tokens,
      };
      const response = await axios.post(apiUrl, requestBody);
      setUserListData(response.data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching manager data:', error);
    }
  };

  const handleInviteUser = async (obj) => {
    // Optimistically update UI first - change icon to gray immediately
    setUserListData((prevData) => ({
      ...prevData,
      data: prevData.data.map((user) => (
        user.userId === obj.userId
          ? { ...user, signup_status: '2' }
          : user
      )),
    }));

    // Set inviting flag to prevent loader from showing
    setIsInviting(true);

    try {
      const response = await axios.post(`${baseUrl}/sendInviteLink`, {
        token: tokens,
        userId: obj.userId,
      });

      if (response?.data?.success) {
        setAppSnackbar({
          isVisible: true,
          message: response?.data?.message || 'Invitation sent successfully',
          type: 'success',
        });
        // Silently refresh data in background without showing loader
        await silentRefreshData();
      } else {
        // Revert the UI change if API failed
        setUserListData((prevData) => ({
          ...prevData,
          data: prevData.data.map((user) => (
            user.userId === obj.userId
              ? { ...user, signup_status: '0' }
              : user
          )),
        }));
        setAppSnackbar({
          isVisible: true,
          message: response?.data?.message || 'Failed to send invitation',
          type: 'error',
        });
      }
    } catch (error) {
      // Revert the UI change if API failed
      setUserListData((prevData) => ({
        ...prevData,
        data: prevData.data.map((user) => (
          user.userId === obj.userId
            ? { ...user, signup_status: '0' }
            : user
        )),
      }));
      // eslint-disable-next-line no-console
      console.error('Error inviting user:', error);
      setAppSnackbar({
        isVisible: true,
        message: error?.response?.data?.message || 'Failed to send invitation',
        type: 'error',
      });
    } finally {
      setIsInviting(false);
    }
  };
  useEffect(() => {
    fetchMangerData();
  }, [isTokenChange]);

  useEffect(() => {
    const databaseRefManUsers = ref(firebaseDatabase, `manager_user_list_updates/${localStorage.getItem('id')}`);
    const dataCallbackMans = (snapshot) => {
      if (snapshot.exists()) {
        fetchMangerData();
      }
    };
    onValue(databaseRefManUsers, dataCallbackMans);
    return () => {
      off(databaseRefManUsers, 'value', dataCallbackMans);
    };
  }, []);
  const updateDummy = (dummy, status) => {
    if (status === 1) {
      dispatch(saveDummy({ [dummy?.draft_id]: dummy }));
    } else {
      dispatch(removeDummy(dummy));
    }
  };
  const handleUserData = (obj) => {
        // temp fix for production #TODO akash
        localStorage.setItem('temp_user_id', obj?.userId);
        // end temp fix
        setbigUserData(obj);
        navigate('/affiliate');
  };
  const closeToast = (draft_id, message, type) => {
    toast.update(draft_id, { closeButton: false, render: message, type: type === 'success' ? toast.TYPE.SUCCESS : toast.TYPE.ERROR, autoClose: 3000 });
    setUploadContainer((prevUploadContainer) => prevUploadContainer.filter((id) => id !== draft_id));
  };
  const updateUploadPercentages = (draft_id, data) => {
    dispatch(saveUploadInfo({ [draft_id]: data }));
  };
  const data = useSelector((state) => state.deleteUpload);
  const deleteAdded = (userObject) => {
    setOpen(false);
    setuserIamChanging(true);
    setEncounterLoading(true);
    const draftIds = Object.keys(uploadPercentages);
    const deletePromises = [];
    draftOfUpload.forEach((draftId) => {
      const uploadStatus = uploadPercentages[draftId];
      setActiveUploads([]);
      setUploadQueue([]);
      // Check if the uploadStatus is not "Please wait"
      if (uploadStatus !== 'Please wait') {
        // const deletePromise = axios
        //   .post(`${baseUrl}/deleteDraftContent`, {
        //     token: getToken(),
        //     draft_id: [draftId], // Pass the current draftId
        //     content_id: [],
        //   })
        //   .then((response) => {
        //     changeFieldFromFirebase(draftId, 'DELETED');
        //     updateDummy(draftId, 0);
        //     updateUploadPercentages(draftId, 'Cancelled');
        //     closeToast(draftId, 'Upload has been canceled by user', 'error');
        //     return response;
        //   })
        //   .catch((error) => {
        //     console.error(`Error deleting items for draftId ${draftId}:`, error);
        //     throw error;
        //   });
        // deletePromises.push(deletePromise);
        changeFieldFromFirebase(draftId, 'DELETED');
        updateDummy(draftId, 0);
        updateUploadPercentages(draftId, 'Cancelled');
        closeToast(draftId, 'Upload has been canceled by user', 'error');
        dispatch(clearUploadDetails());
      }
    });
    // Promise.all(deletePromises)
    //   .then(() => {
    //     setEncounterLoading(false);
    //     setInfoModal(false);
    //     setIamUploading(true);
    //     setuserIamChanging(false);
    //     switchingFunction(userObject);
    //   })
    //   .catch((error) => {
    //     console.error('Error deleting items:', error);
    //   });
      setEncounterLoading(false);
      setInfoModal(false);
      setIamUploading(true);
      setuserIamChanging(false);
      switchingFunction(userObject);
  };
  const CircularProgress = withStyles({
    circle: {
      color: '#5aa5ef !important'
    }
  })(MuiCircularProgress);

  const toggleHidden = (index) => {
    if (hiddenIndices.includes(index)) {
      setHiddenIndices(hiddenIndices.filter((i) => i !== index));
    } else {
      setHiddenIndices([...hiddenIndices, index]);
    }
  };
  const hideManagerUser = (userId, index) => {
    const updatedVisibleEye = [...visibleEye];
    updatedVisibleEye[index] = true;
    setVisibleEye(updatedVisibleEye);
    const API_URL = `${baseUrl}/hideManagerUser`;
    const data = {
      token: getToken(),
      user_id: userId
    };
    axios.post(API_URL, data)
      .then((response) => {
        toggleHidden(userId);
        setAppSnackbar({ isVisible: true, message: response?.data?.message, type: 'error' });
        setVisibleEye((prevVisibleEye) => {
          const updatedVisibleEye = [...prevVisibleEye];
          updatedVisibleEye[index] = false;
          return updatedVisibleEye;
        });
      })
      .catch((error) => {
        setAppSnackbar({ isVisible: true, type: 'error', message: error?.response?.message });
      });
  };
  return (
    <div>
      {
        isOpenInfoModal && (
          <InfoModal
            isVisible={isOpenInfoModal}
            title="Uploading is in progress"
            onHide={() => { setInfoModal(false); }}
            continueButton="Continue with upload"
            userIamChanging={userIamChanging}
            // content="You are now deleting, all videos and photos will now be a draft until you
            // Add them to a new category. Are you sure you want to continue?"
            actionButton="Access user anyway"
            action={() => deleteAdded(userObject)}
            isDelete
          />
        )
      }
    <div className="the_Hieghter">
      {isLoading && !isInviting ? (
        <div style={{ display: 'flex' }}>
          <CircularProgress />
        </div>
      ) : (
        userListData?.data?.map((obj, i) => (
          !hiddenIndices.includes(obj?.userId) && (
          <div className="flexter w100" key={i}>
            <div className="rounder">{obj?.firstname?.charAt(0)?.toUpperCase()}</div>
            <div style={{ position: 'relative', flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <p className="UserName">
                  {obj?.firstname?.charAt(0)?.toUpperCase() + obj?.firstname?.slice(1)}
                  {' '}
                  {obj?.lastname?.charAt(0)?.toUpperCase() + obj?.lastname?.slice(1)}
                </p>
                {obj?.profile_status === 'Incomplete' && (
                  <span style={{
                    backgroundColor: '#FEE2E2',
                    color: '#DC2626',
                    fontSize: '11px',
                    fontWeight: '700',
                    padding: '3px 8px',
                    borderRadius: '12px',
                    border: '1.5px solid #EF4444',
                    fontFamily: 'Montserrat',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    whiteSpace: 'nowrap'
                  }}
                  >
                    Free Plan
                  </span>
                )}
              </div>
              <p className="mySmallMail">
                {obj?.email}
              </p>
            </div>

            {/* Invite Button - Conditional based on signup_status */}
            {/* signup_status: "0" = show invite icon, "1" = hide (invitation completed), "2" = show disabled with "Invitation sent" tooltip */}
            {obj?.signup_status === '0' && (
              <IconButton
                onClick={() => handleInviteUser(obj)}
                style={{ padding: '8px', color: '#5aa5ef' }}
                title="Send invitation"
              >
                <EmailIcon />
              </IconButton>
            )}
            {obj?.signup_status === '2' && (
              <Tooltip title="Invitation already sent" arrow>
                <span>
                  <IconButton
                    disabled
                    style={{ padding: '8px', color: '#ccc', cursor: 'not-allowed' }}
                  >
                    <EmailIcon />
                  </IconButton>
                </span>
              </Tooltip>
            )}

            {/* Access Button - Always shown */}
            <IconButton
              onClick={() => { setUserObject(obj); managerTokenFunction(obj); }}
              style={{ padding: '8px', color: '#5aa5ef' }}
              title="Access user account"
            >
              <ExitToAppIcon />
            </IconButton>

            <HiddenIcon onClick={() => hideManagerUser(obj?.userId, i)} className={visibleEye[i] ? 'visibleEye' : 'hiddenX'} />
          </div>
          )
        ))
      )}
    </div>
    </div>

  );
}

export default ManagerList;
